module.exports = __webpack_public_path__ + "static/media/corpBanner3.36282038.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/corpBanner3.jpg
// module id = 360
// module chunks = 0